<template>
  <div class="loading-skeleton">
    <!-- Header Skeleton -->
    <v-card class="mb-4 skeleton-card" elevation="2">
      <v-card-title class="pa-6">
        <div class="d-flex align-center w-100">
          <v-skeleton-loader type="avatar" class="mr-4"></v-skeleton-loader>
          <div class="flex-grow-1">
            <v-skeleton-loader type="heading" width="200"></v-skeleton-loader>
            <v-skeleton-loader type="text" width="300" class="mt-2"></v-skeleton-loader>
          </div>
          <v-skeleton-loader type="button" width="100"></v-skeleton-loader>
        </div>
      </v-card-title>
    </v-card>

    <!-- Statistics Skeletons -->
    <v-row class="mb-4">
      <v-col v-for="n in 4" :key="n" cols="12" sm="6" lg="3">
        <v-card class="skeleton-stat-card" elevation="6">
          <v-card-text class="pa-6">
            <div class="d-flex align-center justify-space-between">
              <div class="flex-grow-1">
                <v-skeleton-loader type="text" width="120" class="mb-2"></v-skeleton-loader>
                <v-skeleton-loader type="heading" width="80" class="mb-1"></v-skeleton-loader>
                <v-skeleton-loader type="text" width="100"></v-skeleton-loader>
              </div>
              <v-skeleton-loader type="avatar" width="64" height="64"></v-skeleton-loader>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Filter Skeleton -->
    <v-card class="mb-4 skeleton-card" elevation="4">
      <v-card-title class="pb-3">
        <v-skeleton-loader type="text" width="200"></v-skeleton-loader>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-5 pb-4">
        <v-row>
          <v-col cols="12" md="4">
            <v-skeleton-loader type="text" height="40"></v-skeleton-loader>
          </v-col>
          <v-col cols="12" md="3">
            <v-skeleton-loader type="text" height="40"></v-skeleton-loader>
          </v-col>
          <v-col cols="12" md="3">
            <v-skeleton-loader type="text" height="40"></v-skeleton-loader>
          </v-col>
          <v-col cols="12" md="2">
            <v-skeleton-loader type="text" height="40"></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Table Skeleton -->
    <v-card class="skeleton-card" elevation="4">
      <v-card-title class="skeleton-table-header">
        <v-skeleton-loader type="text" width="250" dark></v-skeleton-loader>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-skeleton-loader type="table" :types="customTypes"></v-skeleton-loader>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'LoadingSkeleton',
  data() {
    return {
      customTypes: {
        table: 'table-heading, table-tbody',
      },
    };
  },
};
</script>

<style scoped>
.loading-skeleton {
  animation: fadeIn 0.3s ease-in;
}

.skeleton-card {
  border-radius: 16px !important;
  overflow: hidden;
}

.skeleton-stat-card {
  border-radius: 16px !important;
  background: linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%);
}

.skeleton-table-header {
  background: linear-gradient(135deg, #1976d2 0%, #d32f2f 100%) !important;
  padding: 20px 24px !important;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Pulse animation for skeleton loaders */
.loading-skeleton >>> .v-skeleton-loader__bone {
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
}
</style>
